import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { StorageVariables } from '../shared/constants/app.enum';

export function tokenGetter() {
  return localStorage.getItem(StorageVariables.TOKEN)!;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter,
      },
    }),
  ],
  exports: [RouterModule, TranslateModule, JwtModule],
})
export class CoreModule {}
